import { Component, OnInit, Input } from '@angular/core';
import { FullAuditTrailService } from './full-audit-trail.service';
import { AppConstants } from '../../../shared/constants/constants';
//import { MomentModule } from 'angular2-moment';
@Component({
    selector: 'ch-full-audit-trail',
    templateUrl: 'full-audit-trail.component.html',
    providers: [FullAuditTrailService]
})

export class FullAuditTrailComponent implements OnInit {
    @Input() patientId: string;
    @Input() auditTrailLog: any;
    @Input() consultationId: string;
    public appConstants = AppConstants;
    public klass = 'consultationhistory';
   
    constructor(public fullAuditTrailService: FullAuditTrailService) { }

    ngOnInit() {
        // this.fullAuditTrailService.getFullAuditTrail(this.patientId).subscribe(
        //     (result) => {
        //         if (result) {
        //             const data = result.json();
        //             this.auditTrailLog = data["list"];
        //         }
        //     }
        // )
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/full-audit-trail/full-audit-trail.component.ts